module.exports = __webpack_public_path__ + "img/Looks03.6237135d.jpg";